/*
 * @Author: huangying
 * @Date: 2021-12-31 10:26:36
 * @Last Modified by: huangying
 * @Last Modified time: 2021-12-31 16:06:59
 */
import $ from 'jquery'

export default function initMenu() {
  // 所有菜单
  const $menuList = $('li[data-menuanchor]')
  const $page_height = $('#page_height')
  const menuHeight = $('.top_menu').height()
  $menuList.click(function (event) {
    event.stopPropagation()
    const anchor = $(this).attr('data-menuanchor')
    const activeMenu = $(this).attr('data-activeMenu')
    $.map($menuList, function (menuItem) {
      $(menuItem).removeClass('activeMenu')
      if ($(menuItem).attr('data-activeMenu') == activeMenu) {
        $(menuItem).addClass('activeMenu')
      }
    })
    const scrollTop = $(`div[data-hash=${anchor}]`).offset().top
    $page_height.animate(
      {
        scrollTop: $page_height.scrollTop() + scrollTop - menuHeight,
      },
      { duration: 1000 }
    )
  })

  $page_height.scroll(
    throttle(function () {
      const scrollTop = $page_height.scrollTop()
      for (let i = 0; i < $menuList.length; i++) {
        const $item = $menuList.eq(i)
        const anchor = $item.attr('data-menuanchor')
        const $pageItem = $(`div[data-hash=${anchor}]`)
        const activeMenu = $pageItem.attr('data-menu')
        const thisTopHeight = scrollTop + $pageItem.offset().top - menuHeight
        const thisBottomHeight = thisTopHeight + $pageItem.height()
        //然后设置高亮
        if (
          thisTopHeight - 160 < scrollTop &&
          scrollTop < thisBottomHeight + 160
        ) {
          $.map($menuList, function (menuItem) {
            $(menuItem).removeClass('activeMenu')
            if ($(menuItem).attr('data-activeMenu') == activeMenu) {
              $(menuItem).addClass('activeMenu')
            } 
          })
        }
      }
    }, 50)
  )
}

const throttle = function (func, delay) {
  let prev = Date.now()
  return function () {
    const context = this
    const args = arguments
    const now = Date.now()
    if (now - prev >= delay) {
      func.apply(context, args)
      prev = Date.now()
    }
  }
}
